//Descarga de base agrupada
import JSZip from "jszip";
import { DownloadCSVOptions } from "./downloadCSV";
import { INDICATOR_TYPE_STRUCTURAL } from "../../../../utils/const";
import { saveAs } from "file-saver";
import { DerechoDto } from "../../../../interfaces/OpenData";
import { buildStructuralColumns, escapeCSV, joinProperty, toExcelBuffer, toUTF8CSV } from "./helpers";
import { Period } from "../../../../interfaces/Periods";
import { DownloadFormat } from "./types";

const dataIndicator = [
    'Nombre del indicador',
    'Tipo de indicador',
    'Derecho',
    'Dimensión',
    'Subdimensión',
];

export interface ClusteredBase extends DownloadCSVOptions {
    periods: Period[],
    format?: DownloadFormat;
}

export const downloadIndicatorMetadataBase = async ({ indicators, periods, format }: ClusteredBase) => {
    if (!indicators.length) return;

    const isExcel = format === 'excel';
    const zip = new JSZip();

    const addToZip = (name: string, rows: unknown[][]) => {
        if (isExcel) {
            zip.file(`${name}.xlsx`, toExcelBuffer(rows));
        } else {
            zip.file(`${name}.csv`, toUTF8CSV(rows));
        }
    };

    const structuralIndicators = indicators.filter(ind => ind.tipo_indicador === INDICATOR_TYPE_STRUCTURAL);
    const processResultIndicators = indicators.filter(ind => ind.tipo_indicador !== INDICATOR_TYPE_STRUCTURAL);

    if (structuralIndicators.length > 0) {
        const headerStructural = [
            ...dataIndicator,
            'Grupos prioritarios asociados',
            'Evaluación'
        ];

        const rows = [
            ['Sección indicadores'],
            headerStructural
        ];

        for (const indicator of structuralIndicators) {
            const { data, titulo, tipo_indicador } = indicator;

            if (data && Array.isArray(data) && data.length > 0) {
                const derechos = data as DerechoDto[];
                const columns = buildStructuralColumns(derechos)


                columns.forEach((col) => {
                    const row = [
                        titulo,
                        tipo_indicador,
                        col.derecho,
                        col.dimension,
                        col.subdimension,
                        joinProperty(indicator.grupos_prioritarios, 'nombre'),
                        escapeCSV(col.evaluacion)
                    ];

                    rows.push(row);
                });
            }
        }

        addToZip('indicadores_estructurales', rows);
    }
    if (processResultIndicators.length > 0) {

        const headerProcResult = [
            ...dataIndicator,
            'Variables asociadas',
            'Grupos prioritarios asociados',
            'ODS asociados'
        ];

        const periodYears: string[] = [];

        if (periods.length > 0) {
            const periodHeaders = periods.map(p => {
                const year = p.value.replace('Período', '').trim();
                periodYears.push(year);
                return p.value.replace('Período', 'Evaluación');
            });
            headerProcResult.push(...periodHeaders);
        }

        const rows = [
            ['Sección indicadores'],
            headerProcResult
        ];

        for (const indicator of processResultIndicators) {
            const { titulo, tipo_indicador, breadcrumbs, evaluaciones } = indicator;

            const partsBreadcrumb = breadcrumbs.split('/').map(p => p.trim());

            const row = [
                titulo,
                tipo_indicador,
                partsBreadcrumb[0] || '', // derecho
                partsBreadcrumb[2] || '', // dimension
                partsBreadcrumb[3] || '', // subdimension
                joinProperty(indicator.variables_relacionadas, 'titulo'),
                joinProperty(indicator.grupos_prioritarios, 'nombre'),
                joinProperty(indicator.ods, 'numero'),
            ];

            if (periodYears.length > 0 && evaluaciones) {
                periodYears.forEach(year => {
                    const evaluacion = evaluaciones[year] ?? ' ';
                    row.push(evaluacion);
                });
            }

            rows.push(row);
        }

        addToZip('indicadores_proceso_resultado', rows);
    }

    const zipBlob = await zip.generateAsync({ type: 'blob' });
    saveAs(zipBlob, 'base_metadatos.zip');
}